import {
  UtensilsCrossed,
  ShoppingBag,
  IndianRupee,
  Star,
} from "lucide-react";

import "./ProviderCards.css";

function ProviderStatsCard({ provider }) {

  const formatNumber = (value = 0) =>
    Number(value).toLocaleString("en-IN");

  const stats = [

    {
      title: "Total Foods",
      value: formatNumber(provider.totalFoods),
      icon: <UtensilsCrossed size={22} />,
      color: "#2563EB",
    },

    {
      title: "Orders Completed",
      value: formatNumber(provider.totalOrders),
      icon: <ShoppingBag size={22} />,
      color: "#F59E0B",
    },

    {
      title: "Total Revenue",
      value: `₹${formatNumber(provider.wallet?.totalEarnings)}`,
      icon: <IndianRupee size={22} />,
      color: "#16A34A",
    },

    {
      title: "Average Rating",
      value: provider.averageRating
        ? `${provider.averageRating.toFixed(1)} ★`
        : "0.0 ★",
      icon: <Star size={22} />,
      color: "#A0001C",
    },

  ];

  return (

    <div className="provider-card">

      <h3 className="card-title">

        Business Statistics

      </h3>

      <div className="provider-stats-grid">

        {stats.map((item, index) => (

          <div
            className="provider-stat-box"
            key={index}
          >

            <div
              className="provider-stat-icon"
              style={{
                background: item.color,
              }}
            >

              {item.icon}

            </div>

            <div className="provider-stat-info">

              <p>

                {item.title}

              </p>

              <h2>

                {item.value}

              </h2>

            </div>

          </div>

        ))}

      </div>

    </div>

  );

}

export default ProviderStatsCard;